import { useState } from 'react';
import { useTheme } from '../../hooks/theme';
import { Link, Header } from 'mondrian-react';
import ModalFonts from './components/ModalFonts';
import styles from './styles.module.css';

function Menu({ noHeader }) {
  const [openModalFonts, setOpenModalFonts] = useState(false);

  // const { themeSwitcher } = useTheme();

  return (
    <>
      {/* Menu Top Start, here you can put geolocation, tabs of main page and
      acessibilitys modes */}
      <div className="mdn-Menu-top">
        <div className="mdn-Container">
          <nav className={`mdn-Menu-top-content ${styles['Menu-top-content']}`}>
            <ul className="mdn-Menu-top-list mdn-Menu-top-list-right">
              <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                <i className="mdn-Icon-pcd mdn-Icon--sm"></i>
                <Link
                  inverse
                  className={styles.AccessibilityButton}
                  href="https://www.claro.com.br/institucional/regulatorio/acessibilidade"
                  target="_blank"
                >
                  Acessibilidade
                </Link>
              </li>
              {/* <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                <i className="mdn-Icon-alto-contraste mdn-Icon--sm"></i>
                <Link
                  inverse
                  className={styles.ContrastButton}
                  onClick={themeSwitcher}
                >
                  Contraste
                </Link>
              </li> */}
              <li className="mdn-Menu-top-list-item mdn-Menu-top-list-item-underline">
                <button
                  className={`mdn-Text mdn-Menu-top-action ${styles.ModalFontsButton}`}
                  onClick={() => setOpenModalFonts(true)}
                >
                  <i className="mdn-Icon-diminuir-tamanho mdn-Icon--sm"></i>
                  <i className="mdn-Icon-aumentar-tamanho mdn-Icon--sm"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {/* Menu Top End */}

      {!noHeader && <Header />}

      <ModalFonts
        open={openModalFonts}
        close={() => setOpenModalFonts(false)}
      />
    </>
  );
}

export default Menu;
